import { Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import Button from '../../../components/buttons/Button';
import FieldWrapper from '../../../components/formInputs/FieldWrapper';

export default function SingleOrderPaymentReject({
  setRejectOpen,
  loading,
  submitSubmission
}: {
  setRejectOpen: React.Dispatch<React.SetStateAction<number | null | undefined>>;
  loading?: boolean;
  submitSubmission: (values: any, setErrors: any) => void;
}) {
  const { t } = useTranslation();

  const validationSchema = Yup.object({}).shape({
    comment: Yup.string().required('This field is required')
  });

  return (
    <div className="bg-white p-10 rounded-t-[0.8125rem] lg:rounded-[0.8125rem]">
      <Formik
        initialValues={{
          comment: ''
        }}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={(values, { setErrors }) => {
          submitSubmission(
            {
              status: 2,
              comment: values.comment
            },
            setErrors
          );
        }}
      >
        {(formik) => (
          <Form>
            <h4 className="text-h3 mb-6">{t('reject_payment')}</h4>
            <FieldWrapper
              title={t('comment')}
              inputName={'comment'}
              inputPlaceholder={t('comment')}
              inputError={formik.errors.comment as string}
              inputTouched={formik.touched.comment as boolean}
              textArea
            />
            <div className="buttons">
              <Button type={'button'} onClick={() => setRejectOpen(null)}>
                {t('cancel')}
              </Button>
              <Button loading={loading} type="submit">
                <span className="bold">{t('confirm')}</span>
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

/**
 * import { Form, Formik, FormikProps } from 'formik';
import { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { IStepData } from '../types/interfaces';
import * as Yup from 'yup';
import Button from '../../../components/buttons/Button';
import FieldWrapper from '../../../components/formInputs/FieldWrapper';
import useMultiSelectOptions from '../../../hooks/useMultiSelectOptions';

export default function SingleOrderReject({
  data,
  setRejectOpen,
  loading,
  submitSubmission
}: {
  data: IStepData;
  setRejectOpen: React.Dispatch<React.SetStateAction<boolean>>;
  loading?: boolean;
  submitSubmission: (values: any, setErrors: any) => void;
}) {
  const { t, i18n } = useTranslation();
  const formikRef = useRef<FormikProps<any> | null>(null);

  const selectOptions = useMemo(() => {
    const fields = data?.entities?.flatMap((ele) => (ele?.auto_generate_documents || !ele?.editable_by_customer ? [] : ele.fields));

    return fields?.map((field) => ({
      label: field.label?.[i18n.language as 'en' | 'ar'],
      value: String(field.id)
    }));
  }, [data]);

  const validationSchema = Yup.object({}).shape({
    field_id: Yup.string().required('This field is required'),
    comment: Yup.string().required('This field is required')
  });

  console.log(formikRef, 'formikRef');

  const { element } = useMultiSelectOptions({
    inputName: 'field_id',
    formik: formikRef.current,
    label: t('document'),
    placeholder: t('document'),
    selectOptions: selectOptions || [],
  });

  return (
    <div className="bg-white p-10 rounded-t-[0.8125rem] lg:rounded-[0.8125rem]">
      <Formik
        initialValues={{
          field_id: selectOptions?.[0]?.value ? [selectOptions?.[0]?.value] : [],
          comment: ''
        }}
        innerRef={formikRef}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={(values, { setErrors }) => {
          submitSubmission(
            {
              status: 'rejected',
              [`comments[${values?.field_id}]`]: values?.comment
            },
            setErrors
          );
        }}
      >
        {(formik) => (
          <Form>
            <h4 className="text-h3 mb-6">{t('reject_documents')}</h4>
            {element}
            <FieldWrapper
              title={t('comment')}
              inputName={'comment'}
              inputPlaceholder={t('comment')}
              inputError={formik.errors.comment as string}
              inputTouched={formik.touched.comment as boolean}
              textArea
            />
            <div className="buttons">
              <Button type={'button'} onClick={() => setRejectOpen(false)}>
                {t('cancel')}
              </Button>
              <Button loading={loading} type="submit">
                <span className="bold">{t('confirm')}</span>
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

 */
